import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/controls/Button"
import { IconAwards } from "@components/svg/Icons"
import { Link } from "eddev/routing"
import { AwardMicroCardFragment } from "../../types.graphql"

type Props = AwardMicroCardFragment

export function AwardEntryMicroCard(props: Props) {
  return (
    <Link href={props.uri} className="flex gap-1 pt-3 pb-3 border-b justify-between items-center group @container">
      <div className="flex flex-col gap-2">
        <p className="type-title-s-medium">{props.title}</p>
        <p className="type-title-s-light md:type-body-s-roman">{props.category?.title}</p>
        <div className="stack-x-1 flex-wrap items-start">
          <Chip variant="charcoal" leftIcon={<IconAwards />}>
            {props.merit}
          </Chip>
          <Chip className="w-fit" variant="outline">
            {props.category?.parent?.title}
          </Chip>
        </div>
      </div>
      <div className="flex gap-4 flex-wrap justify-end w-[60%] overflow-hidden h-10">
        {props.artworks?.slice(0, 4)?.map((img, i) => (
          <div key={i} className="h-10">
            <ResponsiveImage className="h-full" fadeOnLoad={false} srcSet={img?.srcSet} aspect={img?.aspect!} />
          </div>
        ))}
      </div>
    </Link>
  )
}
